import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchMonthlyLossReportApi,
  LossReportRequest,
} from "../../api/shrink.api";

export interface ShrinkState {
  reportData: any[];
  loading: boolean;
  error: string | null;
}

const initialState: ShrinkState = {
  reportData: [],
  loading: false,
  error: null,
};

export const fetchMonthlyLossReport = createAsyncThunk<
  any[],
  LossReportRequest & { format: "csv" | "xlsx" },
  { rejectValue: string }
>("shrink/fetchMonthlyReport", async (params, { rejectWithValue }) => {
  try {
    const res = await fetchMonthlyLossReportApi(params);
    return res.data;
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || "Failed to fetch report",
    );
  }
});

const shrinkSlice = createSlice({
  name: "shrink",
  initialState,
  reducers: {
    clearShrinkError: (state) => {
      state.error = null;
    },
    clearReportData: (state) => {
      state.reportData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlyLossReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonthlyLossReport.fulfilled, (state, action) => {
        state.loading = false;
        state.reportData = action.payload;
      })
      .addCase(fetchMonthlyLossReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unknown error";
      });
  },
});

export const { clearShrinkError, clearReportData } = shrinkSlice.actions;
export default shrinkSlice.reducer;
